import { render } from "./ButtonS1.vue?vue&type=template&id=5716689a&scoped=true"
import script from "./ButtonS1.vue?vue&type=script&lang=js"
export * from "./ButtonS1.vue?vue&type=script&lang=js"

import "./ButtonS1.vue?vue&type=style&index=0&id=5716689a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5716689a"

export default script